import { Component } from '@angular/core';
import { AutoCompleteComponent } from '@components/dynamic-form/auto-complete/auto-complete.component';
import { WarrantyModel } from '@/models/tables/warranty.model';

@Component({
  selector: 'app-auto-complete-warranty',
  templateUrl: '../../auto-complete.component.html',
  styleUrls: ['../../auto-complete.component.scss'],
})
export class AutoCompleteWarrantyComponent extends AutoCompleteComponent {
  displayFn(selectedoption: any): string {
    return selectedoption && selectedoption.descrizione ? selectedoption.descrizione : '';
  }

  protected getValue(obj: WarrantyModel) {
    return obj?.descrizione ?? '';
  }
}
